import React from "react";
import { ECLDropDown, ECLThemeImage } from "../../../../eclComponents";
import { translate } from "../../../../utilities/Translate";

const CustomNode = ({ data }) => {
   return (
      <div
         title={data.label}
         style={{
            display: "flex",
            padding: "5px",
            border: "1px solid #777",
            borderRadius: "10px",
            alignItems: "center",
            justifyContent: "center",
         }}
         className={data.userSelect ? "selected-node" : ""}
      >
         <ECLDropDown
            trigger={<ECLThemeImage fontAwesome="ellipsis-vertical" />}
            menuWidth={200}
         >
            <button>{translate("Set As Root")}</button>
         </ECLDropDown>
         <ECLThemeImage fontAwesome="question" />
         <p>{data.label}</p>
      </div>
   );
};

export default CustomNode;
